module.exports = __webpack_public_path__ + "static/img/dde-details.71aeaab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/dde-details.png
// module id = +uPl
// module chunks = 0